<template>
  <div class="w-100">
    <main-hero :hero-title="$t('Welcome to Leads.io')" />
    <div class="row">
      <div class="col">
        <log-in-form />
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import LogInForm from "@/components/form/LogIn";
import MainHero from "@/components/section/MainHero"
import AppFooter from "@/components/footer/AppFooter"
import store from '@/store'

export default {
  name: "Login",
  components: {LogInForm, MainHero, AppFooter},
  beforeRouteEnter: function (to, from, next) {
    if (store.state.USER_STATE === true) {
      next({name: 'dashboard'})
    } else {
      next();
    }
  },
}
</script>

<style lang="scss">

</style>
